// extracted by mini-css-extract-plugin
export default {"info":"_23ufPL7K2a","h-rule":"_34C68zQD51","hRule":"_34C68zQD51","logo":"_3aM3Ugq8s4","further-resources":"_3y6r-RayM0","furtherResources":"_3y6r-RayM0"};
    if(module.hot) {
      // 1625219454403
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  